import Accordion from "../components/accordion";
import AccordionItem from "../components/accordion-item";
import BodyClassName from "react-body-classname";
import detectBreakpoint from "../components/higher-order/detect-breakpoint";
import { connect } from "react-redux";
import GameBoard from "./game-board";
import { getBets, getChatsForTournament, getMyTickets, getRaceEntrants, getRaces, getRacesForTournament, getSession, getTicketsForTournament, getTokenTypes, getTournament, getTournamentsForMyTicketsToday, getUsers } from "../selectors";
import HomePage from "./home-page";
import { isBreakpointLessThan } from "../breakpoints";
import Leaderboard from "../containers/leaderboard";
import React from "react";
import { Route, Switch } from "react-router-dom";
import MyGamesFeed from "../components/my-games-feed";
import TournamentChatsFeed from "../components/tournament-chats-feed";
import { tournamentPostChatMessage } from "../actions/tournament";

class ActivityFeed extends React.PureComponent {
  constructor(props) { super(props);

    this.state = { showChat: true, showMyGames: true };

    this.collapseAll = this.collapseAll.bind(this);
    this.toggleChat = this.toggleChat.bind(this);
    this.toggleMyGames = this.toggleMyGames.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.didTournamentChange(prevProps)) {
      this.collapseAll();
    }
  }

  didTournamentChange(prevProps) {
    var { nextTournament } = this.props;
    var { match: prevMatch, tournament: prevTournament } = prevProps;
    return prevTournament !== nextTournament &&
      nextTournament !== undefined &&
      prevTournament !== undefined &&
      nextTournament.get("id") !== parseInt(prevMatch.params.id);
  }

  collapseAll() {
    this.setState({ showChat: false, showMyGames: false }); // eslint-disable-line react/no-set-state
  }
  toggleChat() {
    var { showChat } = this.state;
    this.setState({ showChat: !showChat }); // eslint-disable-line react/no-set-state
  }

  toggleMyGames() {
    var { showMyGames } = this.state;
    this.setState({ showMyGames: !showMyGames }); // eslint-disable-line react/no-set-state
  }

  render() {
    var {
      bets,
      breakpoint,
      myTickets,
      tournamentPostChatMessage: onPostChat,
      raceEntrants,
      races,
      racesForTournament,
      session,
      tickets,
      tokenTypes,
      tournament,
      tournaments,
      tournamentChats,
      users
    } = this.props;

    if (!session) {
      return null;
    }
    var currentUserId = session.get("user_id");

    var gameChat;
    var leaderboard;
    if (tournament) {
      if (currentUserId) {
        gameChat = (
          <AccordionItem icon="dw-comments" title="Game Chat">
            <HideOverflowOnMobile breakpoint={breakpoint}>
              <TournamentChatsFeed
                currentUserId={currentUserId}
                onPostChat={onPostChat}
                tournament={tournament}
                tournamentChats={tournamentChats}
                users={users} />
            </HideOverflowOnMobile>
          </AccordionItem>
        );
      }

      if (isBreakpointLessThan(breakpoint, "lg")) {
        var leaderboardButtonLabel;

        var ticket = tickets.first();
        if (ticket) {
          var user = users.get(ticket.get("user_id"));
          if (user) {
            leaderboardButtonLabel = [
              <span key="username">
                {user.get("username")}
              </span>,
              <span className="badge badge--orange badge--ghost badge--short" key="score">
                {ticket.get("score")}
              </span>
            ];
          }
        }

        leaderboard = (
          <AccordionItem alwaysShowButtonLabel buttonLabel={leaderboardButtonLabel} icon="dw-list-ordered" title="Leaderboard">
            <HideOverflowOnMobile breakpoint={breakpoint}>
              <Leaderboard
                races={racesForTournament}
                tickets={tickets}
                tournament={tournament} />
            </HideOverflowOnMobile>
          </AccordionItem>
        );
      }
    }

    var myGames;
    if (currentUserId) {
      myGames = (
        <AccordionItem icon="dw-gamepad" title="My Games">
          <HideOverflowOnMobile breakpoint={breakpoint}>
            <MyGamesFeed
              bets={bets}
              myTickets={myTickets}
              raceEntrants={raceEntrants}
              races={races}
              tokenTypes={tokenTypes}
              tournament={tournament}
              tournaments={tournaments} />
          </HideOverflowOnMobile>
        </AccordionItem>
      );
    }
    if (!myGames && !gameChat && !leaderboard) {
      return (
        <div className="l-main">
          <Switch>
            <Route component={HomePage} exact path="/tournaments" />

            <Route component={HomePage} path="/tournaments/list/:list" />

            <Route component={HomePage} path="/tournaments/list/:list/:page" />

            <Route component={GameBoard} path="/tournaments/:id" />
          </Switch>
        </div>
      );
    }
    return (
      <div>
        <Accordion onlyOne={isBreakpointLessThan(breakpoint, "lg")}>
          {myGames}

          {gameChat}

          {leaderboard}
        </Accordion>

        <div className="l-main">
          <Switch>
            <Route component={HomePage} exact path="/tournaments" />

            <Route component={HomePage} path="/tournaments/list/:list" />

            <Route component={HomePage} path="/tournaments/list/:list/:page" />

            <Route component={GameBoard} path="/tournaments/:id" />
          </Switch>
        </div>
      </div>
    );
  }
}

function HideOverflowOnMobile({ breakpoint, children }) {
  if (isBreakpointLessThan(breakpoint, "lg")) {
    return (
      <BodyClassName className="body--overflow-hidden">
        {children}
      </BodyClassName>
    );
  } else {
    return React.Children.only(children);
  }
}

function select(state, props) {
  return {
    bets: getBets(state),
    myTickets: getMyTickets(state),
    raceEntrants: getRaceEntrants(state),
    races: getRaces(state),
    racesForTournament: getRacesForTournament(state, props),
    session: getSession(state),
    tickets: getTicketsForTournament(state, props),
    tokenTypes: getTokenTypes(state),
    tournament: getTournament(state, props),
    tournaments: getTournamentsForMyTicketsToday(state),
    tournamentChats: getChatsForTournament(state, props),
    users: getUsers(state)
  };
}

export default connect(select, { tournamentPostChatMessage })(detectBreakpoint(ActivityFeed));
